'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_s_Array$UnapplySeqWrapper$() {
}
export { $c_s_Array$UnapplySeqWrapper$ as $c_s_Array$UnapplySeqWrapper$ };
$p = $c_s_Array$UnapplySeqWrapper$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_s_Array$UnapplySeqWrapper$;
/** @constructor */
function $h_s_Array$UnapplySeqWrapper$() {
}
export { $h_s_Array$UnapplySeqWrapper$ as $h_s_Array$UnapplySeqWrapper$ };
$h_s_Array$UnapplySeqWrapper$.prototype = $p;
$p.C0 = (function(this$, len) {
  return $j_java$002elang$002e$002dObject.$m_sc_ArrayOps$().C0(this$, len);
});
var $d_s_Array$UnapplySeqWrapper$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_Array$UnapplySeqWrapper$, "scala.Array$UnapplySeqWrapper$", ({
  rt: 1
}));
export { $d_s_Array$UnapplySeqWrapper$ as $d_s_Array$UnapplySeqWrapper$ };
var $n_s_Array$UnapplySeqWrapper$;
function $m_s_Array$UnapplySeqWrapper$() {
  if ((!$n_s_Array$UnapplySeqWrapper$)) {
    $n_s_Array$UnapplySeqWrapper$ = new $c_s_Array$UnapplySeqWrapper$();
  }
  return $n_s_Array$UnapplySeqWrapper$;
}
export { $m_s_Array$UnapplySeqWrapper$ as $m_s_Array$UnapplySeqWrapper$ };
